import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSelectionToSkiptraceCount = () =>
  useBatchSkiptraceStore(store => store.selectionToSkiptraceCount.state)
